import { animate, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Cards } from '../models/Cards';
@Component({
  selector: 'app-product-journey',
  templateUrl: './product-journey.component.html',
  styleUrls: ['./product-journey.component.scss'],
  animations: [
    trigger('openClose', [
      transition('* => closed', [
        animate('1s')
      ])
    ])
  ]
})
export class ProductJourneyComponent {
  setups = [];
  beds = [];
  departments = [];
  products = [];

  selected_setup: any = {};
  selected_bed: any = {};
  selected_department: any = [];

  product_cards:any = [];

  _view_recommendations: boolean = false;
  recommended_product_cards: any = [];
  constructor(private cards: Cards, private router: Router){
    console.log(cards.cards);
    this.setups = [{
      id: 1,
      label: 'Hospital',
      is_active: 0
    }, {
      id: 2,
      label: 'Pharmacy',
      is_active: 0
    }, {
      id: 3,
      label: 'Laboratory',
      is_active: 0
    }, {
      id: 4,
      label: 'Radiology',
      is_active: 0
    }, {
      id: 5,
      label: 'Clinic',
      is_active: 0
    }, {
      id: 6,
      label: 'Medical Institute',
      is_active: 0
    }];

    this.beds = [{
      id: 1,
      label: 'Below 20',
      is_active: 0,
      parent: [1,6]
    }, {
      id: 2,
      label: '20 - 50',
      is_active: 0,
      parent: [1,6]
    }, {
      id: 3,
      label: '50 - 100',
      is_active: 0,
      parent: [1,6]
    }, {
      id: 4,
      label: '100 - 300',
      is_active: 0,
      parent: [1,6]
    }, {
      id: 5,
      label: '300 - 500',
      is_active: 0,
      parent: [1,6]
    }, {
      id: 6,
      label: '500 +',
      is_active: 0,
      parent: [1,6]
    }]

    this.departments = [{
      id: 1,
      label: 'OPD',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: true
    }, {
      id: 2,
      label: 'IPD',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: false
    }, {
      id: 3,
      label: 'Day Care',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: true
    }, {
      id: 4,
      label: 'Emergency',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: false
    }, {
      id: 5,
      label: 'Pharmacy',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: true
    }, {
      id: 6,
      label: 'Laboratory',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: true
    }, {
      id: 7,
      label: 'Radiology',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: true
    }, {
      id: 8,
      label: 'Nursing',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: false
    }, {
      id: 9,
      label: 'Dialysis',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: true
    }, {
      id: 10,
      label: 'EMR/Prescription',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: true
    }, {
      id: 11,
      label: 'MRD',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: false
    }, {
      id: 12,
      label: 'Appointment',
      is_active: 0,
      parent: [1,2,3,4,5,6],
      include_clinic: true
    }];
    this.product_cards = cards.cards;
  }

  selectLevel1(item: any){
    this.selected_setup = null;
    this._view_recommendations = false;
    this.setups.forEach((slug:any) => {
      slug.is_active = 0;
    });
    this.beds.forEach((slug: any) => {
      slug.is_active = 0;
    });
    this.departments.forEach((slug: any) => {
      slug.is_active = 0;
    });

    if(item){
      item.is_active = 1;
    }

    this.selected_setup = item;
    this.selected_bed = null;
    this.selected_department = [];
  }

  selectLevel2(item:any){
    this.selected_bed = null;
    this._view_recommendations = false;
    this.beds.forEach((slug: any) => {
      slug.is_active = 0;
    });
    this.departments.forEach((slug: any) => {
      slug.is_active = 0;
    });

    if(item){
      item.is_active = 1;
    }

    this.selected_bed = item;
    this.selected_department = [];
  }

  selectLevel3(item:any){
    this.selected_department = [];

    if(item){
      item.is_active = !item.is_active;
    }

    this.departments.forEach((slug: any) => {
      slug.is_active ? this.selected_department.push(slug.id) : null;
    });
  }

  checkForLevelParent(slug: any, level: any){
    let has_parent: boolean = false;
    if(this.selected_setup && this.selected_setup.id && this.selected_setup.id == 5){
      if(slug.include_clinic){
        has_parent = true;
      }
    } else {
      slug.parent.forEach(element => {
        if(element == level.id){
          has_parent = true;
        }
      });
    }

    return has_parent;
  }

  checkCard(card){
    let show_card: boolean = false;
    let _has_setup: boolean = false;
    let _has_bed: boolean = false;
    let _has_department: boolean = false;
    if(card){
      if(card.parent.setup && card.parent.setup.length){
        card.parent.setup.forEach(parent => {
          if(parent == this.selected_setup.id){
            _has_setup = true;
          }
        })
      }

      if(card.parent.bed && card.parent.bed.length && (this.selected_setup.id == 1 || this.selected_setup.id == 6)){
        card.parent.bed.forEach(parent => {
          if(parent == this.selected_bed.id){
            _has_bed = true;
          }
        })
      }

      if(card.parent.department && card.parent.department.length){
        card.parent.department.forEach(parent => {
          let _find = this.selected_department.find(x => x == parent)
          if(_find){
            _has_department = true;
          }
        })
      }
    }

    if(this.selected_setup.id == 1 || this.selected_setup.id == 6){
      if(_has_setup && _has_department){
        show_card = true
      }
    } else if (this.selected_setup.id == 2 || this.selected_setup.id == 3 || this.selected_setup.id == 4){
      if(_has_setup){
        show_card = true
      }
    } else if (this.selected_setup.id == 5){
      if(_has_setup && _has_department){
        show_card = true
      }
    }
    return show_card;
  }

  storeChoices(){
    let obj = {
      selected_setup: this.selected_setup,
      selected_bed: this.selected_bed,
      selected_department: this.selected_department
    }

    let stored_json = JSON.stringify(obj);

    localStorage.setItem('stored_choices', stored_json);
    localStorage.removeItem('manual_selection')

    this.router.navigate(["/product/list"]);

  }

  viewRecommendations(){
    this.recommended_product_cards = [];
    this._view_recommendations = true;

    this.product_cards.forEach(element => {
      if(this.checkCard(element)){
        console.log(element);
        this.recommended_product_cards.push(element);
      }
    });
  }

  checkCardsShow(){
    let _check: boolean = false;
    if(this.selected_setup.id == 2 || this.selected_setup.id == 3 || this.selected_setup.id == 4){
      _check = true;
    } else if(this.selected_setup.id == 5){
      if(this.selected_department && this.selected_department.length){
        _check = true
      }
    } else if(this.selected_setup.id == 1 || this.selected_setup.id == 6) {
      if(this.selected_bed && this.selected_bed.id){
        if(this.selected_department && this.selected_department.length){
          console.log(this.selected_department)
          _check = true;
        }
      }
    } else {
      _check = false;
    }

    return _check;
  }
}

// parent: {
//   level_1: [1,5,6],
//   level_2: [1,2],
//   level_3: [1,2,12]
// }

/* 

Level 1 is always present

When level 1 has Hospital, or Medical institute selected, Level 2 (beds) will appear

When 

*/